module.exports = __webpack_public_path__ + "static/media/w3.e811ed27.png";